'use client'

import { motion } from 'framer-motion'

import { useIsMounted } from '@repo/hooks'

export function AnimatedTitle({ text, className }: { text: string; className?: string }) {
  const isAnimated = useIsMounted()

  return (
    <div className="relative">
      <motion.h1
        className={`text-title-lg text-center ${className}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {text.split('').map((char, index) => (
          <motion.span
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.05 }}
          >
            {char}
          </motion.span>
        ))}
      </motion.h1>
      {isAnimated && (
        <motion.div
          className="via-background/80 dark:via-background/80 pointer-events-none absolute inset-0 h-20 bg-gradient-to-r from-transparent to-transparent"
          initial={{ x: '-100%' }}
          animate={{ x: '100%' }}
          transition={{ duration: 2, delay: 3, repeat: Infinity, repeatDelay: 10 }}
        />
      )}
    </div>
  )
}
